import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=2a2f0ec0&scoped=true&"
import script from "./TagSelect.vue?vue&type=script&lang=js&"
export * from "./TagSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=2a2f0ec0&prod&scoped=true&lang=scss&"
import style1 from "./TagSelect.vue?vue&type=style&index=1&id=2a2f0ec0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f0ec0",
  null
  
)

export default component.exports